/**
 * Plus 席位授权服务
 */

import { apiService } from './api'
import type {
  ClientPlusApiResponse,
  ClientPlusSummary,
  ClientPlusUsersData,
} from '@/types/clientPlus'

const CLIENT_PLUS_ENDPOINT = '/api/user/client-plus' as const

export async function getClientPlusSummary(): Promise<ClientPlusSummary> {
  const response = await apiService.get<ClientPlusApiResponse<ClientPlusSummary>>(
    `${CLIENT_PLUS_ENDPOINT}/summary`
  )
  return response.data
}

export async function listClientPlusUsers(): Promise<ClientPlusUsersData> {
  const response = await apiService.get<ClientPlusApiResponse<ClientPlusUsersData>>(
    `${CLIENT_PLUS_ENDPOINT}/users`
  )
  return response.data
}

export async function assignClientPlus(userId: string): Promise<void> {
  await apiService.post<ClientPlusApiResponse<{ message: string }>>(
    `${CLIENT_PLUS_ENDPOINT}/assign`,
    { userId }
  )
}

export async function unassignClientPlus(userId: string): Promise<void> {
  await apiService.post<ClientPlusApiResponse<{ message: string }>>(
    `${CLIENT_PLUS_ENDPOINT}/unassign`,
    { userId }
  )
}
